'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

/**
 * Custom react hook to do something on update and not mount
 *
 * @param effect Will be executed on update
 * @param deps If present, effect will only activate if the values in the list change.
 */

var useDidUpdate = function useDidUpdate(effect, deps) {
  var hasMounted = React.useRef(false);
  React.useEffect(function () {
    if (!hasMounted.current) {
      hasMounted.current = true;
      return;
    }

    effect();
  }, deps);
};

exports.default = useDidUpdate;
